import type { Ref } from 'vue';
import {
  toRef,
} from 'vue';

import type { DashboardPeriodOptions } from '../types';
import { useDashboardStore } from '../store';

export interface DashboardFiltersComposable {
  merchantId: Ref<number | undefined>;
  period: Ref<DashboardPeriodOptions>;
}

export default function useDashboardFilters(): DashboardFiltersComposable {
  const dashboardStore = useDashboardStore();

  const merchantId = toRef(dashboardStore, 'selectedMerchantId');
  const period = toRef(dashboardStore, 'selectedPeriod');

  return {
    merchantId,
    period,
  };
}
